import { Breadcrumb } from 'components';
import { Navigate, Outlet } from 'react-router';
import { Tickets } from './Tickets';
import { Calendar } from './Calendar';
import { route as tasks } from './Tasks';
import { MyCampaigns } from 'modules/campaign/dashboard/MyCampaigns';
import { Summary } from 'modules/campaign/dashboard/Summary';

export const route = {
  path: '/dashboard',
  element: (
    <>
      <Breadcrumb>Dashboard</Breadcrumb>
      <Outlet />
    </>
  ),
  children: [
    {
      path: `campaigns/:view?/*`,
      element: <MyCampaigns />,
    },
    {
      path: 'summary',
      element: <Summary />,
    },
    {
      path: 'tickets/*',
      element: <Tickets />,
    },
    {
      path: 'calendar/*',
      element: <Calendar />,
    },
    tasks,
    {
      index: true,
      element: <Navigate to="campaigns" replace />,
    },
  ],
};
